function collectionSort() {
  const winLocation = window.location;
  $('.sort-holder select').on('change', function() {
    const $this = $(this);
    const sortval = $this.val();
    window.location.href = winLocation.origin + winLocation.pathname + '?sort_by=' + sortval;
  })
  if (winLocation.href.match(/\?sort_by/)) {
    const getSortValue = winLocation.href.split('sort_by=')[1];
    $('.sort-holder select').val(getSortValue);
  }
}

export default collectionSort();



// WEBPACK FOOTER //
// ../markup/assets/js/collection-sort.js